import React, { forwardRef } from 'react'
import styled from '@emotion/styled'
import { useNavigate } from 'react-router-dom'

import { useAuth } from 'core/auth'
import { useI18n } from 'core/language/api'
import { useLoginModal } from 'shared/hooks'

import { Button, LineButton, PageHeader, PageWrapper } from 'components'
import { NftList } from 'modules/nft-list'
import { Footer } from './components/Footer'

interface HomeProps {
    onContact?: () => void
}

export const Home = forwardRef<HTMLDivElement, HomeProps>(({ onContact }, _ref) => {
    const {
        methods: { t }
    } = useI18n()
    const {
        methods: { show }
    } = useLoginModal()
    const navigate = useNavigate()
    const { account } = useAuth()

    return (
        <>
            <Wrapper>
                <PageHeader
                    title="Manage Uploads"
                    className="header"
                    right={
                        account && (
                            <div className="float-right flex items-center">
                                <LineButton
                                    className="create-single-button"
                                    onClick={() => navigate('upload')}
                                >
                                    {t('Upload Media File')}
                                </LineButton>
                                <LineButton
                                    className="create-multiple-button"
                                    onClick={() => navigate('upload/multiple')}
                                >
                                    {t('Upload Zipped Media File')}
                                </LineButton>
                            </div>
                        )
                    }
                />
                <Content>{account ? <NftList /> : <Button onClick={show}>Connect a wallet</Button>}</Content>
            </Wrapper>
            <Footer />
        </>
    )
})

const Content = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: calc(100vh - 68px - 120px - 128px - 90px);
`

const Wrapper = styled(PageWrapper)`
    display: block;

    .create-single-button {
        margin-left: 0;
    }
`
